import { render, staticRenderFns } from "./StatusLegend.vue?vue&type=template&id=46bef078&scoped=true&"
import script from "./StatusLegend.vue?vue&type=script&lang=js&"
export * from "./StatusLegend.vue?vue&type=script&lang=js&"
import style0 from "./StatusLegend.vue?vue&type=style&index=0&id=46bef078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bef078",
  null
  
)

export default component.exports